import { css } from 'styled-system/css';

export const floatBetSlipButtonStyle = {
	root: css({
		base: {
			display: 'none',
			boxShadow: '0px 12px 12px 0px {colors.blackOpacity.12}',
		},
		_mars: {
			color: 'secondary.500',
			bgColor: 'white.1',
			border: '1px solid {colors.secondary.500}',
		},
		_active: {
			display: 'block',
			animation: 'parlay-bounce 500ms linear',
		},
		_dark: {
			boxShadow: '0px 12px 12px 0px {colors.blackOpacity.54}',
		}
	}),
	icon: css({ 
		base: {
			width: '36px',
			height: '36px'
		} 
	}),
	badge: css({
		base: {
			position: 'absolute',
			top: '-6px',
			width: '20px',
			height: '20px',
			lineHeight: '1em',
			rounded: '20px',
			bgColor: 'status.negative',
			color: 'whiteOpacity.100',
			_ltr: {
				right: '-8px',
			},
			_rtl: {
				left: '-8px',
			},
		},
	}),
	alertIcon: css({
		base: {
			position: 'absolute',
			top: '-6px',
			color: 'var(--special-06)',
			w: '18px',
			h: '18px',
			animation: 'grow-shrink 500ms linear',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			bgColor: 'white',
			borderRadius: '28px',
			mx: '5px',
			_ltr: {
				right: '-10px',
			},
			_rtl: {
				left: '-10px',
			},
			'& .icon--ticket-exclamation': {
				transform: 'scale(2.0)',
			}
		},
		_mars: {
			color: '#F33333'
		}
	}),
	pushAside: css({
		base: {
			_ltr: {
				mr: '-383px',
			},
			_rtl: {
				ml: '-383px',
			},
		}
	})
}